import { Fragment, ReactNode } from 'react'

import { Shipment } from 'src/types/shipments'

const dayMonthDateFormat = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
})
export const formatDayMonthDate = (isoDate: string) =>
  dayMonthDateFormat.format(Date.parse(isoDate))

const dayShortMonthDateFormat = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
})
export const formatDayShortMonthDate = (isoDate: string) =>
  dayShortMonthDateFormat.format(Date.parse(isoDate))

const monthDateFormat = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
})
export const formatMonthDate = (isoDate: string) =>
  monthDateFormat.format(Date.parse(isoDate))

export const multilineAddress = ({
  address: { name, address1, address2, city, state, zip, country },
  includeCountry,
}: {
  address: Shipment['address']
  includeCountry: boolean
}): { string: string; node: ReactNode } => {
  const pieces = [
    name,
    address1,
    address2,
    city && state && zip ? `${city}, ${state} ${zip}` : null,
    includeCountry ? country : null,
  ].filter((datum) => !!datum)

  const rows = pieces.map((piece) => (
    <Fragment key={piece}>
      {piece}
      <br />
    </Fragment>
  ))

  return {
    string: pieces.join('\n'),
    node: <>{rows}</>,
  }
}
